export const parseBitfield = (value: number) => {
  return value.toString(2).padStart(32, '0').split('').reverse();
};
